import axios from "@/axios";

const endpoint = "/places";

const Places = {
  search: async (payload) => {
    return axios
      .post(`${endpoint}/search`, {
        searchQuery: {
          industry: payload.industry,
          businessName: payload.business_name,
          state: payload.state,
          city: payload.city,
          zip: payload.zip,
        }
      })
      .then(({ places }) => places.map(place => ({
        value: place.name,
        title: place.displayName.text,
        description: place.formattedAddress
      })))
      .catch((error) => {
        console.log(error);
        return [];
      });
  },
  save: async (placeName) => {
    return axios.post("/places", { placeName: placeName })
  }
};

export default Places;
